import React from 'react';
import Transactions from '../Transactions';
import { Card } from 'antd';

const PendingTransactions = () => (
  <Card className="gx-card" title="Processing Transactions">
    <Transactions
      transactionType="CHARGEBACK,REFUND,SETTLEMENT,COLLECTION,DISBURSEMENT"
      transactionStatus="PROCESSING,PENDING,CONFIRMING"
    />
  </Card>
);

export default PendingTransactions;
